import {Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, AfterViewChecked, ChangeDetectorRef, ElementRef, TemplateRef, ContentChild, Output, EventEmitter, AfterViewInit, ContentChildren} from '@angular/core';
import { AbsPaginatedGrid, TYPE_DONNEE } from 'src/app/app.models';
import * as XLSX from 'xlsx';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

@Component({
    selector: 'abw-datatable',
    templateUrl: './abw-datatable.component.html',
    styleUrls: ['./abw-datatable.component.scss']
})
export class AbwDatatableComponent implements OnInit, OnChanges, AfterViewInit {
    filteredDatas: any[] = [];
    filteredText: string = null;
    isDatatableRefreshed = true;
    TYPE_DONNEE = TYPE_DONNEE;
    ColumnMode = ColumnMode;
    @Input() datas = new AbsPaginatedGrid();
    @Input() columns: { prop: string, name: string, hasCustomHtml: boolean, typeDonnees: TYPE_DONNEE, width?: number, paramsColumn?: any }[] = [];
    @Input() getRowClass = (row) => '';
    @Input() getCellClass = ({ row, column, value }) => '';
    @Output() onPageChanged = new EventEmitter<any>();
    @Output() onRowSelected = new EventEmitter<any>();
    @Output() onToggle = new EventEmitter<any>();
    @ViewChild("table") public table: DatatableComponent;
    @ContentChildren('customHtml') customHtmlTemplate: TemplateRef<any>[];
    @ContentChild('actions') actionsTemplate: TemplateRef<any>;

    constructor(
        private _cdf: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes.datas && !!changes.datas.currentValue) {
            this.columns = this.datas.mAbsColumns.filter(column => column.mVisible).map(column => ({
                prop: column.mDatasource,
                name: column.mTitle,
                hasCustomHtml: column.mHasCustomHtml,
                typeDonnees: column.mTypeDonnees,
                width: column.width,
                paramsColumn: column.paramsColumn
            }));
            this.doFilterDatas();
            window.dispatchEvent(new Event('resize'));
            this._cdf.detectChanges();
        }
    }
    
    ngAfterViewInit() {
        window.dispatchEvent(new Event('resize'));
        this._cdf.detectChanges();
    }

    doFilterDatas(_searchText?: string) {
        this.filteredText = _searchText;
        this.filteredDatas = this.datas.mPagination.mDatas;
        if (!!_searchText) {
            this.filteredDatas = this.filteredDatas.filter(row => {
                return Object.keys(row).filter(item => {
                    return !!row[item] && String(row[item]).toLowerCase().indexOf(_searchText.toLowerCase()) !== -1;
                }).length > 0;
            });
        }
    }
  
    doExportDatasAction() {
        if (!this.datas) { return; }
        const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet(this.filteredDatas);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, 'Datasource.xlsx');
    }

    refresh() {
        //this.isDatatableRefreshed = false;
        this.doFilterDatas(this.filteredText);
        setTimeout(() => {
            //this.isDatatableRefreshed = true;
            this.filteredDatas = [...this.filteredDatas];
            this._cdf.detectChanges();
        }, 10);
    }

    checkIfActionsAvailable() {
        return this.columns.findIndex(c => c.prop == '_ACTIONS_') > -1;
    }

    pageChanged(event: any) {
        this.onPageChanged.emit(event);
    }

    selectRow(_event: any) {
        if (_event.type == 'click') {
            this.onRowSelected.emit({ row: _event.row, cellIndex: _event.cellIndex });
        }
    }

    toggle(row: any, propName: string, event) {
        this.onToggle.emit({ data: row, property: propName, event: event });
    }
}